import React from "react";
import styles from "./index.module.scss";
import { Button, Divider, Icon, message } from "antd";
import Space from "components/Space";
import { Link, useRouteMatch } from "react-router-dom";
import classNames from "classnames";
import UserAvatar from "../../../Components/UserAvatar";
import moment from "moment";
import {
    AskListItem,
    deleteAnsweringQuestion
} from "../../../../../API/discuss";
import { isTrue } from "../../../../../Utils/filter";
import useDeviceType from "../../../../../Utils/useDeviceType";
import useModalHandler from "../../../../../Utils/v3/useModalHandler";
import EditAksModal from "../../../Components/EditAksModal";
import { errorMessage } from "../../../../../Utils/useRequest";
import DeleteConfirm from "../../../../../components/DeleteConfirm";

interface ListItemProps {
    data: AskListItem;
    reload: () => void;
}

export default function ListItem({ data, reload }: ListItemProps) {
    const { path } = useRouteMatch();
    const { isPC, isMobile } = useDeviceType();

    const editModal = useModalHandler({
        component: EditAksModal
    });

    function openModal() {
        if (data) {
            console.log(data);

            const {
                batchNo,
                courseNo,
                courseName,
                courseSeq,
                customerCode,
                uuid
            } = data;

            editModal.open({
                batchNo: batchNo!,
                courseNo: courseNo!,
                courseName: courseName!,
                courseSeq: courseSeq!,
                customerCode: customerCode!,
                onSuccess: () => {
                    reload();
                    editModal.close();
                },
                uuid
            });
        }
    }

    const loginStuNo = localStorage.getItem("STUDENTNO");

    async function onDelete() {
        const { batchNo, courseNo, courseSeq, customerCode, uuid } = data;
        try {
            await deleteAnsweringQuestion({
                batchNo,
                courseNo,
                courseSeq,
                customerCode,
                uuid
            });
            reload();
            message.success("删除成功");
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <div
            className={classNames(styles.root, {
                [styles.new]: isTrue(data.hasPartIn)
            })}>
            {isPC && (
                <div className={styles.front}>
                    <UserAvatar
                        userNo={data.askerNo}
                        userName={data.askerName}
                    />
                </div>
            )}

            <div className={styles.body}>
                <h1 className={styles.course}>
                    {data.courseName} {data.courseNo}-{data.courseSeq}
                    {isTrue(data?.canEdit) && (
                        <Space
                            className={styles.buttons}
                            split={<Divider type="vertical" />}>
                            <DeleteConfirm onSuccess={onDelete}>
                                <Button type="link">删除</Button>
                            </DeleteConfirm>
                            <Button type="link" onClick={openModal}>
                                编辑
                            </Button>
                        </Space>
                    )}
                </h1>

                <div className={styles.overs}>
                    <Link
                        className={styles.link}
                        to={`${path}/${data.batchNo}/${data.courseNo}/${data.courseSeq}/${data.uuid}`}
                    />
                    <div className={styles.title}>{data.questionTitle}</div>
                    <div className={styles.hide}>
                        <div
                            className={styles.summary}
                            dangerouslySetInnerHTML={{
                                __html: data.questionContent
                            }}
                        />
                    </div>
                </div>

                <Space className={styles.info} size={5}>
                    <span>{data.askerName}</span>
                    <span>
                        {moment(data.createTime).format("YYYY-MM-DD HH:mm")}
                    </span>
                </Space>
            </div>

            <Space className={styles.tail} direction="vertical">
                <Space className={styles.statics} size={20}>
                    <span>
                        <Icon type="solution" /> {data.statics.partInCount}
                        人参与
                    </span>
                    <span>
                        <Icon type="message" /> {data.statics.replyCount}条发言
                    </span>
                </Space>
            </Space>

            {editModal.render()}
        </div>
    );
}
